import { useState } from "react";
import { router } from "@inertiajs/react";
import Header from "../Component/Header";

export default function Create({ salesOrders = [], payments = [] }) {
    const [form, setForm] = useState({
        inv_code: "",
        so_id: "",
        pay_id: "",
    });
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const setField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const submit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        setErrors({});

        try {
            await window.axios.post(
                "/panel/invoices",
                {
                    inv_code: form.inv_code,
                    so_id: Number(form.so_id),
                    pay_id: Number(form.pay_id),
                },
                { headers: { Accept: "application/json" } }
            );

            router.visit("/panel/invoices");
        } catch (error) {
            setErrors(error?.response?.data?.errors ?? {});
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Header />
            <main id="content" className="pb-14 sm:pb-16">
                <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto">
                    <div className="py-2 sm:pb-0 sm:pt-5 space-y-5">
                        <p className="text-sm text-muted-foreground-1">Invoice</p>

                        <form onSubmit={submit} className="grid grid-cols-1 lg:grid-cols-6 gap-5">
                            <div className="lg:col-span-4 space-y-4">
                                <div className="flex flex-col bg-card border border-card-line overflow-hidden rounded-xl shadow-2xs">
                                    <div className="py-3 px-5 border-b border-card-header">
                                        <h2 className="font-semibold text-foreground">Create Invoice</h2>
                                    </div>

                                    <div className="p-5 space-y-4">
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Invoice Code</label>
                                            <input
                                                type="text"
                                                value={form.inv_code}
                                                onChange={(e) => setField("inv_code", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                                placeholder="e.g. INV-0001"
                                            />
                                            {errors.inv_code && <p className="mt-1 text-xs text-red-600">{errors.inv_code}</p>}
                                        </div>

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Sales Order</label>
                                            <select
                                                value={form.so_id}
                                                onChange={(e) => setField("so_id", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                            >
                                                <option value="">Select Sales Order</option>
                                                {salesOrders.map((salesOrder) => (
                                                    <option key={salesOrder.so_id} value={salesOrder.so_id}>
                                                        {salesOrder.so_code}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.so_id && <p className="mt-1 text-xs text-red-600">{errors.so_id}</p>}
                                        </div>

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Payment</label>
                                            <select
                                                value={form.pay_id}
                                                onChange={(e) => setField("pay_id", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                            >
                                                <option value="">Select Payment</option>
                                                {payments.map((payment) => (
                                                    <option key={payment.pay_id} value={payment.pay_id}>
                                                        {payment.pay_code}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.pay_id && <p className="mt-1 text-xs text-red-600">{errors.pay_id}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={() => router.visit("/panel/invoices")}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-layer border border-layer-line text-layer-foreground"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={submitting}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-primary border border-primary-line text-primary-foreground disabled:opacity-50"
                                    >
                                        {submitting ? "Saving..." : "Save Invoice"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
}
